import React from 'react'

const AgentDetails = () => {
  return (
    <div>AgentDetails</div>
  )
}

export default AgentDetails